package com.milta.core.localization.translations.fr

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Importer un fichier",
    analysingTitle = "Analyse du fichier…",
    analysingSubtitle = "Nous identifions les colonnes et détectons les livraisons présentes dans le tableau.",
    fileSentSuffix = "envoyé à l'instant",
    structuredFormatBannerTitle = "Format reconnu.",
    structuredFormatBannerMessage = "Les colonnes ont été mappées automatiquement, aucune correction nécessaire.",
    columnsInterpretedBannerTitle = "Colonnes interprétées automatiquement.",
    columnsInterpretedBannerMessage = "Vérifiez les livraisons signalées avant de les ajouter.",
    completePillLabel = "Tout est complet",
    invalidFileTitle = "Fichier non pris en charge.",
    invalidFileMessage = "Importez un fichier Excel (.xlsx) ou CSV (.csv) valide.",
    chooseAnotherFileButton = "Choisir un autre fichier",
    extractionFailedTitle = "Impossible de lire ce fichier.",
    extractionFailedMessage = "Le tableau semble vide ou sa structure n'a pas été reconnue — vérifiez son contenu ou saisissez les livraisons manuellement.",
    retryWithNewFileButton = "Réessayer avec un autre fichier",
    serviceUnavailableTitle = "Service d'analyse temporairement indisponible.",
    serviceUnavailableMessage = "Réessayez dans quelques instants, ou complétez cette livraison manuellement en attendant.",
)
